// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2EQ6o","ranges":"BmiRanges_ranges__M6dfy"};